

































/* Created- 22 - Mar - 2019 */

import { Component, Vue, Prop } from "vue-property-decorator";
import { IArticle } from "../../../Models/ArticleModels/article";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";

@Component(
	{
		name: "ParticaArticlePreview",
		components: { ButtonList }
	})
export default class ParticaArticlePreview extends Vue {
	@Prop() private article: IArticle; // your data
	@Prop() private show: boolean;
	@Prop() private showbuttons: boolean;
	@Prop() private buttons: ButtonConfig[];

	private getimage() {
		if (this.article !== undefined) {
			return this.article.getFeaturedImage(this.$store.state.config.thumburl, 600);
		}
		return "";
	}

	private buttonClicked(clicked: ParticaEvent) {
		clicked.item = this.article.articleId;
		this.$emit("partica-event", clicked);
	}


}
